import { ActionIcon, Badge, Box, Button, Group, Paper, Stack, Text } from '@mantine/core';
import { IconPlus, IconTrash } from '@tabler/icons-react';
import { DataExportSchemaConfigListItem } from '../types';

type ConfigListPanelProps = {
  configs: DataExportSchemaConfigListItem[];
  selectedConfigId: string | null;
  onSelectConfig: (configId: string) => void;
  onCreateConfig: () => void;
  onDeleteConfig: (configId: string) => void;
  isDeleting: boolean;
};

export default function ConfigListPanel({
  configs,
  selectedConfigId,
  onSelectConfig,
  onCreateConfig,
  onDeleteConfig,
  isDeleting,
}: ConfigListPanelProps) {
  return (
    <Stack gap="sm">
      <Group justify="space-between" align="center">
        <Text fw={600} size="sm">
          Configurations
        </Text>
        <Button
          size="xs"
          variant="light"
          leftSection={<IconPlus size={14} />}
          onClick={onCreateConfig}
        >
          New
        </Button>
      </Group>
      <Stack gap="xs">
        {configs.map(config => (
          <Paper
            key={config.id}
            withBorder
            p="sm"
            radius="sm"
            style={{
              cursor: 'pointer',
              borderColor:
                selectedConfigId === config.id ? 'var(--mantine-color-blue-5)' : undefined,
              backgroundColor:
                selectedConfigId === config.id ? 'var(--mantine-color-blue-0)' : undefined,
            }}
            onClick={() => onSelectConfig(config.id)}
          >
            <Group justify="space-between" wrap="nowrap">
              <Box style={{ minWidth: 0, flex: 1 }}>
                <Group gap="xs" wrap="nowrap">
                  <Text size="sm" fw={500} truncate>
                    {config.displayName}
                  </Text>
                  {config.isDefault && (
                    <Badge size="xs" variant="light" color="blue">
                      Default
                    </Badge>
                  )}
                </Group>
              </Box>
              {!config.isDefault && (
                <ActionIcon
                  variant="subtle"
                  color="red"
                  size="sm"
                  loading={isDeleting}
                  onClick={e => {
                    e.stopPropagation();
                    onDeleteConfig(config.id);
                  }}
                >
                  <IconTrash size={14} />
                </ActionIcon>
              )}
            </Group>
          </Paper>
        ))}
      </Stack>
    </Stack>
  );
}
